import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

interface StatusIconProps {
  enabled: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const StatusIcon: React.FC<StatusIconProps> = ({ 
  enabled, 
  size = 'md',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  const baseClasses = enabled ? 'text-green-600' : 'text-red-600';
  const iconClasses = `${sizeClasses[size]} ${baseClasses} ${className}`;

  return enabled ? (
    <CheckCircle className={iconClasses} />
  ) : (
    <XCircle className={iconClasses} />
  );
}; 